import React from 'react';
import { RouteComponentProps } from 'react-router';
import { observer } from 'mobx-react';
import { Stack, Text } from '@servicetitan/design-system';
import { lazyInject } from '../../ioc';
import { RouteParams } from '../signature-routes';
import { SignatureStore } from '../../stores/signature.store';
import { SignModalStore } from '../../stores/sign-modal.store';
import { DocumentList } from '../document-list/document-list';
import { EmptySignaturePage } from '../empty-signature-page/empty-signature-page';
import { VisitAssistantHeader } from '../visit-assistant-header/visit-assistant-header';
import { VisitAssistantSidebar } from '../visit-assistant-sidebar/visit-assistant-sidebar';
import { PageContainer } from '../page-container/page-container';
import styles from './signature-page.less';

@observer
export class SignaturePageContainer extends React.Component<RouteComponentProps<RouteParams>, any> {
    @lazyInject(SignatureStore) signaturesStore!: SignatureStore;
    @lazyInject(SignModalStore) signModalStore!: SignModalStore;

    async componentDidMount() {
        const { visitActionId } = this.props.match.params;

        if (!visitActionId) {
            return;
        }

        await this.signaturesStore.getVisitActionRequest(visitActionId);
        this.signaturesStore.startDocumentsPolling();
        this.signModalStore.showPdfLoader();
        this.signModalStore.setVisitActionId(visitActionId);
    }

    componentWillUnmount() {
        this.signaturesStore.stopDocumentsPolling();
    }

    render() {
        const { documents, businessUnitOfficialName, isOnlineEstimateCompleted, showSidebar } =
            this.signaturesStore;
        const showDocumentList = !!(documents && (documents.length || isOnlineEstimateCompleted));
        let sidebarStackDirection: 'row' | 'column' = 'row';

        return (
            <PageContainer>
                <VisitAssistantHeader
                    showTenantName
                    isHomePage
                    tenantName={businessUnitOfficialName}
                />
                <Stack
                    direction={sidebarStackDirection}
                    className={showSidebar ? styles.sidebarOffset : ''}
                >
                    {showSidebar && <VisitAssistantSidebar />}
                    <Stack direction="column" className={styles.pageContent}>
                        {}
                        <Text bold size={6} className="p-t-5">
                            Visit Assistant
                        </Text>
                        {}
                        {showDocumentList ? (
                            <DocumentList documents={documents} />
                        ) : (
                            <EmptySignaturePage />
                        )}
                    </Stack>
                </Stack>
            </PageContainer>
        );
    }
}
